angular.module('impactx.product').directive('ixPriceRule', function () {
    return {
        scope: {
            priceRule: '=',
            recalcFunc: '&',
            trns: '=',
            ixDisabled: '=',
            index: '@',
            orderUnit: "=",
            allowFracAmounts: "=",
            maxPriceDigits: "=",
            useMaxPriceDigits: "=",
            onlyInput: "=",
            dialogData: "=",
            hidePaddingAndHeader: "=",
            targetReadOnly: '=',
            useMaxPriceDigitsForAllDerived: "=",
            maxPriceDigitsForDerived: "=",
        },
        controller: 'PriceRuleCtrl',
        controllerAs: 'priceRuleCtrl',
        restrict: 'E',
        templateUrl: 'modules/product/templates/pricerule.tmpl.html',

        link: function (scope) {
            if (scope.onlyInput) {
                const watchTargetAndSource = function (newVal) {
                    var targetPopupCtrl = angular.element(document.querySelector('#target_popup_'+scope.index)).controller('ngModel');
                    if (newVal && impactX.isDefined(scope, 'priceRule.targetPopup.selected.id') === impactX.isDefined(scope, 'priceRule.source.selected.id')) {
                        if (targetPopupCtrl) {
                            targetPopupCtrl.$setValidity('issame', false);
                        }
                        angular.element(document.querySelector('#source_'+scope.index))
                            .controller('ngModel').$setValidity('issame2', false);
                    } else {
                        if (targetPopupCtrl) {
                            targetPopupCtrl.$setValidity('issame', true);
                        }
                        angular.element(document.querySelector('#source_'+scope.index))
                            .controller('ngModel').$setValidity('issame2', true);
                    }
                }
                scope.$watch(function () {
                        return impactX.isDefined(scope, 'priceRule.targetPopup.selected.id');
                    },
                    watchTargetAndSource
                );
                scope.$watch(function () {
                        return impactX.isDefined(scope, 'priceRule.source.selected.id');
                    },
                    watchTargetAndSource
                );
            }
        }
    };
});